import React, { useState } from "react";
import "./Register.css";
import { useHistory } from "react-router-dom";
import { auth } from "./firebase";
import firebase from "firebase";

function Register() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [abb] = useState("");

  const register = (event) => {
    event.preventDefault(); //stops the refresh
    // register logic
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        var user = firebase.auth().currentUser;
        user.updateProfile({
          displayName: firstname + " " + lastname,
        });
        user.sendEmailVerification().then(function() {
            // Email sent.
            alert("Verification email sent to " + email)
          }).catch(function(error) {
            // An error happened.
            alert(error)
          });
        saveRegisteredUser(user);
       
//   // email verification
//         // ***********************
//         const actionCodeSettings = {
//           // URL you want to redirect back to. The domain (www.example.com) for this
//           // URL must be in the authorized domains list in the Firebase Console.
//           url: "http://www.huronpines.com",
//           // This must be true.
//           handleCodeInApp: true,
//           iOS: {
//             bundleId: "com.example.ios",
//           },
//           android: {
//             packageName: "com.example.android",
//             installApp: true,
//             minimumVersion: "12",
//           },
//           dynamicLinkDomain: "example.page.link",
//         };
//         // console.log("action",email);
//         firebase
//         .auth()
//           .sendSignInLinkToEmail(email, actionCodeSettings)
//           .then(() => {
//             alert("Verification email sent");
//             console.log("email sent to", email);
//             // The link was successfully sent. Inform the user.
//             // Save the email locally so you don't need to ask the user for it again
//             // if they open the link on the same device.
//             window.localStorage.setItem("emailForSignIn", email);
//             // ...
//           })
//           .catch((error) => {
//             var errorCode = error.code;
//             var errorMessage = error.message;
//             // ...
//           });
        //   *******************************************************************************
        //create a user and log in and redirect to homepage
        history.push("/login");
      })
      .catch((e) => alert(e.message));
  };

  const saveRegisteredUser = (u) => {
    firebase
      .firestore()
      .collection("golfers")
      .doc(lastname + firstname + Date.now())
      .set({
        // text: input.value,
        timestamp: Date.now(),
        first: firstname,
        last: lastname,
        email: email,
        abb: abb,
        uid: u.uid,
        cell: mobile,
      })
      .then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };

  return (
    <div className="register">
      <img className="register__logo" src="/logo512.png" alt="" />

      <div className="register__container">
        <h1>Register</h1>
        <form>
          <h5>E-mail</h5>
          <input
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            type="email"
            placeholder="Email Address"
            required
          />
          <h5>Password</h5>
          <input
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            placeholder="Password"
            required
          />
          <h5>First Name</h5>
          <input
            value={firstname}
            onChange={(event) => setFirstName(event.target.value)}
            type="text"
            required
            placeholder="First Name"
          />
          <h5>Last Name</h5>
          <input
            value={lastname}
            onChange={(event) => setLastName(event.target.value)}
            type="text"
            required
            placeholder="Last Name"
          />
          <h5>Mobile Phone</h5>
          <input
            value={mobile}
            onChange={(event) => setMobile(event.target.value)}
            type="text"
            placeholder="Cell Number"
          />
          {/* <h5>Name Abbreviation</h5>
                    <input value={abb} onChange={event => setAbb(event.target.value)} placeholder="Abbreviation for Skins" type="text" required/> */}
          {/* <button onClick={login} type="submit" className= "login__signInButton">Sign in</button>*/}
          <button
            onClick={register}
            className="login__RegisterButton"
            type="submit"
          >
            Create your Golf Account
          </button>
        </form>
      </div>
    </div>
  );
}

export default Register;
